import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, User } from '@types'

interface prepaymentsState {
  loadingStatus: LoadingState
  message: string
  prepayments: User[]
  totalPrepayment: number
  prepaymentAmount: number
}

export interface PrepaymentResponse {
  result: User[]
  totalPrepayment: number
  prepaymentAmount: number
  total: number
}

const initialState: prepaymentsState = {
  loadingStatus: 'NOT_STARTED',
  message: '',
  prepayments: [],
  totalPrepayment: 0,
  prepaymentAmount: 0
}

const prepaymentsSlice = createSlice({
  name: 'prepayments',
  initialState,

  reducers: {
    getPrepayments: state => {
      return {
        ...state,
        loadingStatus: 'LOADING',
        message: ''
      }
    },
    requestInvoice: state => {
      return {
        ...state,
        loadingStatus: 'LOADING',
        message: ''
      }
    },
    getPrepaymentsSuccess: (state, action: PayloadAction<PrepaymentResponse>) => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        prepayments: action.payload.result,
        totalPrepayment: action.payload.totalPrepayment,
        prepaymentAmount: action.payload.prepaymentAmount
      }
    },
    getPrepaymentsFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearPrepaymentsMessage: state => {
      return {
        ...state,
        message: ''
      }
    },
    clearPrepayments: _state => {
      return initialState
    }
  }
})

export const prepaymentsLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.prepayments.loadingStatus, (state: GlobalState) => state.prepayments.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)

export const selectPrepayments = createDraftSafeSelector(
  [(state: GlobalState) => state.prepayments.prepayments],
  prepayments => prepayments || []
)

export const selectTotalPrepayment = createDraftSafeSelector(
  [(state: GlobalState) => state.prepayments.totalPrepayment],
  totalPrepayment => totalPrepayment
)

export const selectPrepaymentAmount = createDraftSafeSelector(
  [(state: GlobalState) => state.prepayments.prepaymentAmount],
  prepaymentAmount => prepaymentAmount
)

export const {
  getPrepayments,
  getPrepaymentsFailed,
  getPrepaymentsSuccess,
  requestInvoice,
  clearPrepaymentsMessage
} = prepaymentsSlice.actions
export default prepaymentsSlice.reducer
